// extracted by mini-css-extract-plugin
export default {"fullWidth":"aq-z","image":"bq-z","lazyLoadPicture":"cq-z","lazyLoadSpinner":"dq-z","lazyLoadSpin":"eq-z","lazyLoadImage":"fq-z","hasStyledAspectRatio":"gq-z"};